export default [
  { text: 'Pallet Number', value: 'palletNum' },
  { text: 'Loaded', value: 'totalLoads' },
  { text: 'Unloaded', value: 'totalUnloads' }
];
